import React, { Component } from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./login_screen.css";
import { Input, Button, Form, Row, Col, Typography } from "antd";
import AppFieldError from "../../component/form/app_field_error/app_field_error";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import config from "../../../data/constant/config";
import UtilBloc from "../../../bloc/util_bloc";
import AuthBloc from "../../../bloc/auth_bloc";
import { Redirect, withRouter } from "react-router-dom";
import Labels from "../../constant/labels";
import LanguageBloc from "../../../bloc/language_bloc";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import AppDialog from "../../component/app_dialog/app_dialog";
import App_loading_dialog from "../../dialog/app_loading_dialog";

const { Title, Text } = Typography;

//LoginScreen
class LoginScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);

    this.state = {
      client: Config.context,
      route: routeParams,
      username: "",
      password: "",
      isLoggedIn: false,
      loaded: false,
      loading: true,
      passwordVisible: false,
      errorpassword: null,
      errorLogin: null,
      errorusername: null,
      validatedPassword: false,
      validatedUsername: false,
      email: "",
      seconds_remain: 59,
      minutes_remain: 9,
      remain: null,
      loginError: ""
    };
    sessionStorage.clear();
    //this.loadLabels();
    /* localStorage.removeItem("PRUESUB_SELECTED_LANG");
    sessionStorage.removeItem("verifiedOtp");
    sessionStorage.removeItem("dataUser");
    sessionStorage.removeItem("otpVerificationMethod"); */
  }

  /* async loadLabels() {
    await LanguageBloc.fetchLabelsFromAPI().then((result)=>{
      this.setState({
        loaded: true,
        loading:false
      })
    }).catch(()=>{
      this.setState({
        loaded: true,
        loading:false
      })
    });    
  } */

  stateUserName() {
    return this.state.username;
  }

  statePassWord() {
    return this.state.password;
  }

  stateIsLoggedin() {
    return this.state.isLoggedIn;
  }

  //stateDisableButton
  stateValidated() {
    return this.state.validatedPassword && this.state.validatedPassword;
  }

  componentDidMount() {
    let language = LanguageBloc.getSelectedLanguage();
    let defaultChecked;
    if (language == config.locale.en) {
      defaultChecked = false;
    } else {
      defaultChecked = true;
    }
    this.setState({
      defaultChecked,
    });
  }

  componentWillUnmount() {
    clearInterval(this.myIntervalErrorOtp);
  }
  
  async onLogin() {
    this.setState({
      loginError: "",
      loading: true
    })
    let username = this.stateUserName();
    let password = this.statePassWord()?.replace(/-/g, "");
    let payload = {
      "certId": username,
      "mbrId": password
    }

    AuthBloc.login(payload)
      .then(async (result) => {
        //console.log("RESULT", result)
        if (result.success) {
          this.setState({
            isLoggedIn: true,
            loading: false,
          }, () => {
            const expiryTime = Date.now() + 30 * 60 * 1000; // 30 minutes from now
            sessionStorage.setItem("session_expiry", expiryTime.toString());
            AuthBloc.saveAccessToken(result.data?.data.token)
            AuthBloc.saveCertificateNo(username)
            AuthBloc.saveNRICNo(password)   
            window.history.replaceState(null, "", `/${this.state.client}`);         
            window.location.href = `/${this.state.client}/${Config.routes.generic.client_details_screen}/personal/view`;
          });
        } else {
          this.setState({
            loading: false,
            loginError: AuthBloc.getErrDescByCode(result?.errorCode)
          });
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
        });
      });
  }

  async logOutPortal() {
    let certId = this.stateUserName();
    AuthBloc.logOutPortal(certId)
      .then(async (result) => {
        if (result.success) {

        } else {
          this.setState({
            loading: false,
            loginError: AuthBloc.getErrDescByCode(result?.errorCode)
          });
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
        });
      });
  }

  // Render Loading Content
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <App_loading_dialog isLoading={this.state.loading} />
      </div>
    );
  }


  validateNRIC = (value) => {
    const regex = /^\d{6}-\d{2}-\d{4}$/; // Format: 920317-1059-54
    if (!regex.test(value)) {
      return "Please enter valid NRIC";
    }

    // Extract date part (first 6 digits)
    const datePart = value.substring(0, 6);
    const year = parseInt(datePart.substring(0, 2), 10);
    const month = parseInt(datePart.substring(2, 4), 10);
    const day = parseInt(datePart.substring(4, 6), 10);

    // Handle year adjustment (assuming NRIC uses 1900s or 2000s)
    const fullYear = year < 50 ? 2000 + year : 1900 + year;

    // Validate date
    const date = new Date(fullYear, month - 1, day);
    if (
      date.getFullYear() !== fullYear ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return "Please enter valid NRIC with a valid date.";
    }

    return ""; // No errors
  };

  handleNRICChange = (e) => {
    const value = e.target.value;
    const errorMessage = this.validateNRIC(value);

    this.setState({
      password: value,
      loginError: "",
      validatedPassword: errorMessage ? false : true,
      nricError: errorMessage
    })

  };

  handleTakafulChange = (e) => {
    const value = e.target.value;
    const errorMessage = this.validateTakaful(value);

    this.setState({
      username: value,
      loginError: "",
      validatedUserName: errorMessage ? false : true,
      takafulError: errorMessage,
    });
  };

  validateTakaful = (value) => {
    const regex = /^[A-Z0-9]{8}-[A-Z0-9]{5}$/; // Format: XXXXXXX-XXXXX
    if (!regex.test(value)) {
      return "Please enter a valid Takaful Certificate Schedule no. (XXXXXXX-XXXXX)";
    }

    // Optional: Ensure the total length is exactly 14 characters (including `-`)
    if (value.length !== 14) {
      return "Takaful Certificate Schedule no. must be exactly 14 characters including the hyphen.";
    }

    return ""; // No errors
  };

  renderLoginPage() {
    return (
      <div className="no-scroll">
        <div className="container mt-5">
          <div className="d-flex align-items-center justify-content-center mb-5">
            <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/images/cuepacs_login_banner.png`
              }
              alt="myCUEPACSCare"
              className="img-fluid"
              style={{ height: "100px" }}
            />
          </div>
          <div className="row border rounded shadow p-4">
            {/* Left Section: Form */}
            <div className="col-md-6">
              <h5 className="fw-bold">
                Welcome to myCUEPACSCare Portal<br />
                <span className="fw-bold fst-italic">Selamat datang ke Portal myCUEPACSCare</span>
              </h5>
              <p>Please enter your details to register/login.<br />
                <span className="fst-italic">Sila masukkan butiran anda untuk mendaftar/log masuk</span>
              </p>

              <Form ref={this.formRef} onFinish={this.onFinish} layout="vertical">
                {/* Takaful Input */}
                <Form.Item
                  label={
                    ""
                  }
                  validateStatus={this.state.takafulError ? "error" : ""}
                  help={this.state.takafulError || ""}
                  name="takafulNo"
                  rules={[{ required: true, message: "Takaful Certificate Schedule no./ No. Jadual Sijil Takaful" }]}
                >
                  <Input
                    placeholder="Takaful Certificate Schedule no./ No. Jadual Sijil Takaful"
                    className="form-control"
                    maxLength={14}
                    style={{ height: "42px" }}
                    onChange={(e) => {
                      this.handleTakafulChange(e)
                      /* this.setState({
                        username: e.target.value,
                        loginError: "",
                        validatedUserName: e.target.value ? true : false
                      }) */
                    }}
                  />
                </Form.Item>

                {/* NRIC Input */}
                <Form.Item
                  label={""}
                  name="nricNo"
                  validateStatus={this.state.nricError ? "error" : ""}
                  help={this.state.nricError || ""}
                  rules={[{ required: true, message: "Please enter NRIC no." }]}
                >
                  <Input
                    placeholder="NRIC no./ No. Kad Pengenalan (xxxxxx-xx-xxxx)"
                    className="form-control"
                    style={{ height: "42px" }}
                    onChange={(e) => {
                      this.handleNRICChange(e)
                    }}
                  />
                </Form.Item>
                {
                  this.state.loginError && <div className="ant-form-item-explain-error mb-3">
                    {
                      this.state.loginError?.en
                    }
                    <br />
                    <i>
                      {
                        this.state.loginError?.bm
                      }
                    </i>
                  </div>
                }

                {/* Button */}
                <div className="mb-3">
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    className="w-50"
                    style={{ backgroundColor: "#ff7f50", borderColor: "#ff7f50", height: "42px", borderRadius: "8px" }}
                    disabled={this.stateValidated() == true ? false : true}
                    onClick={(e) => {
                      this.onLogin();
                    }}
                  >
                    <b>Continue / <i><strong>Teruskan</strong></i></b>
                  </Button>
                </div>
              </Form>
            </div>

            {/* Right Section: Image */}
            <div className="col-md-6 d-flex align-items-center justify-content-center">
              <img
                width={"70%"}
                src={
                  GeneralBloc.getAssetsContextPath() +
                  `/assets/images/cuepacs_login_right_picture.png`
                }
                alt="myCUEPACSCare"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </div>

    );
  }

  render() {
    return this.stateIsLoggedin() ? (
      <Redirect
        to={`/${this.state.client}/${Config.routes.generic.client_details_screen}`}
      />
    ) : (
      this.renderLoginPage()
    );
  }
}

export default withRouter(LoginScreen);
